(function (root, factory) {
  'use strict';
  var core = factory();
  if (typeof module === 'object' && module.exports) module.exports = core;
  if (root) root.ChaoyangInstallationCore = core;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var REVIEW_MAX_AGE = 90 * 24 * 60 * 60 * 1000;
  // Enough for every bounded form field, consent text and links without losing the closing.
  var MESSAGE_MAX_LENGTH = 4000;
  var COPY_EMAIL = 'yorozu-ec-division@yorozubutsuryu.jp';
  var SUBJECT = 'トラックタイヤの持ち込み交換について（対応可否の確認）';
  var STORE_ORIGIN = 'https://chaoyangjapan.myshopify.com';
  var OFFICIAL_LINE_LINK = 'https://line.me/R/ti/p/%40364bxhii';
  var VEHICLE_LABELS = {
    light: '小型トラック',
    medium: '中型トラック',
    heavy: '大型トラック',
    trailer: 'トレーラー',
    all_trucks: 'トラック',
    '小型トラック': '小型トラック',
    '中型トラック': '中型トラック',
    '大型トラック': '大型トラック',
    'トレーラー': 'トレーラー'
  };

  function text(value, maxLength) {
    if (typeof value !== 'string' && typeof value !== 'number') return '';
    return String(value).replace(/[\u0000-\u001f\u007f<>]/g, ' ')
      .replace(/\s+/g, ' ').trim().slice(0, maxLength);
  }

  function messageText(value) {
    if (typeof value !== 'string') return '';
    return value.replace(/\r\n?/g, '\n').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f<>]/g, '')
      .trim().slice(0, MESSAGE_MAX_LENGTH);
  }

  function purchaseQuantity(value) {
    if (typeof value !== 'number' && typeof value !== 'string') return 0;
    var raw = String(value).trim();
    if (!/^\d+$/.test(raw)) return 0;
    var quantity = Number(raw);
    return Number.isSafeInteger(quantity) && quantity >= 1 ? quantity : 0;
  }

  function referenceNumber(value) {
    return typeof value === 'string' && value.length === 15 && /^CY-[A-Fa-f0-9]{12}$/.test(value) ? value : '';
  }

  function buildProductReturnUrl(productPath, quantity) {
    // An allowlisted local handle cannot navigate off-site, alter carts or carry extra parameters.
    if (typeof productPath !== 'string' || /[\s\\%?#]/.test(productPath)
      || !/^\/(?:products|pages(?:\/quote-product)?)\/[A-Za-z0-9][A-Za-z0-9_-]{0,199}$/.test(productPath)) return '';
    var count = purchaseQuantity(quantity);
    return count ? productPath + '?quantity=' + count : '';
  }

  function normalizePostal(value) {
    if (typeof value !== 'string') return '';
    var normalized = value.replace(/[０-９]/g, function (character) {
      return String.fromCharCode(character.charCodeAt(0) - 0xFEE0);
    }).replace(/^[\s\u3000]*〒?/, '').replace(/[\s\u3000\-‐‑‒–—―−ー－]/g, '');
    return /^\d{7}$/.test(normalized) ? normalized : '';
  }

  function parsePostalResults(payload) {
    if (!payload || payload.status !== 200 || !Array.isArray(payload.results)) return [];
    var seen = Object.create(null);
    return payload.results.slice(0, 100).reduce(function (results, entry) {
      if (!entry || typeof entry.address1 !== 'string' || typeof entry.address2 !== 'string'
        || typeof entry.address3 !== 'string') return results;
      var postal = normalizePostal(entry.zipcode);
      var prefecture = text(entry.address1, 20);
      var city = text(entry.address2, 60);
      var town = text(entry.address3, 80);
      if (!postal || !prefecture || !city || !/^(北海道|東京都|京都府|大阪府|.{2,3}県)$/.test(prefecture)) return results;
      var key = [postal, prefecture, city, town].join('|');
      if (!seen[key]) {
        seen[key] = true;
        results.push({ postal: postal, prefecture: prefecture, city: city, town: town });
      }
      return results;
    }, []);
  }

  function regionName(region) {
    if (!region || typeof region !== 'object') return '';
    return [text(region.prefecture, 20), text(region.city, 60), text(region.town, 80)].filter(Boolean).join('');
  }

  function buildMapUrl(context) {
    context = context || {};
    var postal = normalizePostal(context.postal);
    var region = regionName(context);
    var suppliedPostal = context.postal === undefined || context.postal === null ? '' : String(context.postal).trim();
    if ((suppliedPostal && !postal) || !text(context.prefecture, 20) || !text(context.city, 60) || !region) return '';
    var vehicle = VEHICLE_LABELS[context.vehicle] || 'トラック';
    var query = ['日本', postal, region, vehicle, 'トラックタイヤ 持ち込み交換'].filter(Boolean).join(' ');
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
  }

  function isHttpsSource(source) {
    var raw = typeof source === 'string' ? source : source && source.url;
    if (typeof raw !== 'string' || raw.length > 2048) return false;
    try {
      var url = new URL(raw);
      return url.protocol === 'https:' && !!url.hostname && !url.username && !url.password;
    } catch (error) {
      return false;
    }
  }

  function selectWorkshops(records, region, vehicle, now) {
    if (!Array.isArray(records) || !region || typeof region !== 'object' || !text(vehicle, 40)) return [];
    var prefecture = text(region.prefecture, 20);
    var city = text(region.city, 60);
    var nowValue = now === undefined ? Date.now() : new Date(now).getTime();
    if (!prefecture || !Number.isFinite(nowValue)) return [];
    var unique = Object.create(null);
    return records.filter(function (record) {
      // Publication approval is internal source review, not a claim of partnership.
      if (!record || record.publicationApproved !== true
        || record.carryInConfirmed !== true || record.truckServiceConfirmed !== true || !text(record.name, 100)
        || text(record.prefecture, 20) !== prefecture || !text(record.city, 60)
        || !Array.isArray(record.vehicleTypes)
        || (record.vehicleTypes.indexOf(vehicle) === -1 && record.vehicleTypes.indexOf('all_trucks') === -1)
        || !Array.isArray(record.sources) || !record.sources.length || !record.sources.every(isHttpsSource)
        || typeof record.reviewedAt !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(record.reviewedAt)) return false;
      // Workshop verification dates are maintained in Japan, not UTC midnight.
      var reviewValue = /^\d{4}-\d{2}-\d{2}$/.test(record.reviewedAt)
        ? record.reviewedAt + 'T00:00:00+09:00' : record.reviewedAt;
      var reviewDate = new Date(reviewValue).getTime();
      var age = nowValue - reviewDate;
      if (!Number.isFinite(reviewDate) || age < 0 || age > REVIEW_MAX_AGE) return false;
      var key = text(record.id, 100) || [record.name, record.prefecture, record.city].join('|');
      if (unique[key]) return false;
      unique[key] = true;
      return true;
    }).sort(function (left, right) {
      var leftMatch = text(left.city, 60) === city ? 0 : 1;
      var rightMatch = text(right.city, 60) === city ? 0 : 1;
      return leftMatch - rightMatch;
    });
  }

  function buildInquiry(context) {
    context = context || {};
    var quantity = purchaseQuantity(context.quantity);
    var quantityLabel = quantity ? quantity + '本' : '未定';
    var postal = normalizePostal(context.postal);
    var area = regionName(context.region);
    var reference = referenceNumber(context.reference);
    var productUrl = buildProductReturnUrl(context.productPath, context.quantity);
    var lines = [
      (text(context.shopName, 100) || 'ご担当者') + '様',
      '',
      (text(context.customerName, 80) ? text(context.customerName, 80) + 'と申します。' : '') + 'トラックタイヤの持ち込み交換について相談したく、ご連絡しました。',
      '',
      '検討中のタイヤ：' + (text(context.product, 180) || 'CHAOYANG（銘柄は検討中）'),
      'タイヤサイズ：' + (text(context.size, 80) || '確認中'),
      '交換希望本数：' + quantityLabel,
      '車両：' + (VEHICLE_LABELS[context.vehicle] || text(context.vehicle, 60) || '確認中'),
      '相談先の店舗：' + (text(context.shopName, 100) || '確認中'),
      '交換希望時期：' + (text(context.timing, 100) || '相談のうえ決定'),
      '商品の受け取り：' + (text(context.delivery, 100) || '店舗への直送が可能か確認したい')
    ];
    if (reference) lines.push('参照番号：' + reference);
    lines.push('',
      '以下について、ご案内いただけますでしょうか。',
      '1．上記車両・サイズ・本数の持ち込み交換に対応可能か',
      '2．交換料金と追加費用の有無（廃タイヤ処分費用を含む）',
      '3．希望時期に交換できますか。難しい場合は最短の作業可能日と、このメールで予約できるかを教えてください。',
      context.directShipping === 'unavailable'
        ? '4．店舗へタイヤを持参する際の受付方法（直送受取不可の案内を確認しています）'
        : '4．タイヤの直送を希望する場合、' + (text(context.shopAddress, 200) ? '送り先は「' + text(context.shopName, 100) + '／' + text(context.shopAddress, 200) + '」でよろしいでしょうか。' : '店舗へ直接配送できますか。') + '受取可能日・指定の宛名も教えてください。',
      '',
      '対応内容と費用を確認してから、商品の注文を進めたいと考えております。'
    );
    if (text(context.notes, 600)) lines.push('', '補足：' + text(context.notes, 600));
    if (context.shareWithYorozu === true) {
      lines.push('', 'タイヤの購入・配送の確認のため、販売元の株式会社ヨロズ物流をCCに入れています。',
        '差し支えなければ「全員に返信」でご回答いただけますと幸いです。');
    }
    if (productUrl) lines.push('', '購入検討商品の確認：' + STORE_ORIGIN + productUrl);
    // The workshop email link is deliberately free of customer and inquiry parameters.
    if (text(context.arrival, 100)) lines.push('', 'タイヤの到着予定：' + text(context.arrival, 100));
    lines.push('', 'お手数をおかけしますが、よろしくお願いいたします。');
    return messageText(lines.join('\n'));
  }

  function buildPurchaseInquiry(context) {
    context = context || {};
    var quantity = purchaseQuantity(context.quantity);
    var reference = referenceNumber(context.reference);
    // Explicit field allowlist: no workshop, region, free notes or customer contact fields.
    var lines = [
      '【タイヤの在庫・購入相談】',
      '商品：' + (text(context.product, 180) || '相談のうえ決定'),
      'サイズ：' + (text(context.size, 80) || '確認中'),
      '本数：' + (quantity ? quantity + '本' : '未定')
    ];
    if (reference) lines.push('参照番号：' + reference);
    lines.push('交換場所を確認してから購入したいので、在庫・納期と購入方法を教えてください。');
    return lines.join('\n');
  }

  function buildEmailDraft(email, message, options) {
    if (typeof email !== 'string' || email.length > 254 || /[\r\n%?&#]/.test(email)) return '';
    var recipient = email.trim();
    if (!/^[A-Za-z0-9][A-Za-z0-9._+-]*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/.test(recipient)
      || recipient.indexOf('..') !== -1) return '';
    var body = messageText(message);
    if (!body) return '';
    options = options || {};
    var subject = text(options.subject, 180) || SUBJECT;
    // Legacy callers retain CC; UI callers pass the explicit, initially unchecked consent.
    var share = options.shareWithYorozu === undefined || options.shareWithYorozu === true;
    var parameters = [];
    if (share) parameters.push('cc=' + encodeURIComponent(COPY_EMAIL));
    parameters.push('subject=' + encodeURIComponent(subject), 'body=' + encodeURIComponent(body));
    return 'mailto:' + recipient + '?' + parameters.join('&');
  }

  function buildLineUrl(basicId, message) {
    if (typeof basicId !== 'string') return '';
    var id = basicId.trim().replace(/^@/, '');
    if (!/^[A-Za-z0-9._-]{3,32}$/.test(id)) return '';
    var body = messageText(message);
    if (!body) return '';
    return 'https://line.me/R/oaMessage/' + encodeURIComponent('@' + id) + '/?' + encodeURIComponent(body);
  }

  return Object.freeze({
    parseQuantity: purchaseQuantity,
    normalizePostal: normalizePostal,
    parsePostalResults: parsePostalResults,
    buildMapUrl: buildMapUrl,
    selectWorkshops: selectWorkshops,
    buildProductReturnUrl: buildProductReturnUrl,
    buildInquiry: buildInquiry,
    buildPurchaseInquiry: buildPurchaseInquiry,
    buildEmailDraft: buildEmailDraft,
    buildLineUrl: buildLineUrl
  });
}));
